<section class="truckModel">
    <h1 class="tabMobSidePadding truckModelHeading"> {{ 'components/footer/truckrange' | lowercase | translate}} </h1>
    <div class="truckModel-div">
        <div class="tabMobSidePadding truckModel-div-wrapper">
            <ng-container *ngFor="let list of truckmodelObject; let i = index">

                <div [id]="list.scrollPath"
                    [ngClass]="(i % 2) === 0 ? 'truckModel-div-wrapper-paddingRight' : 'truckModel-div-wrapper-paddingleft'">
                    <volvo-truck-model-home-skeleton *ngIf="isLoading[i]"></volvo-truck-model-home-skeleton>

                    <div [hidden]="isLoading[i]">
                        <img [src]="assetService.getAssetUrl(list.url)" class="volvo-imgDiv-volvoImg"
                            [routerLink]="list.path | localize" *ngIf="i !== 4 && i !== 5" (load)="onImageLoad(i)"
                            (click)="logTruckModelButtonClick(list.name)" alt="" />
                        <a [href]="list.path" *ngIf="i === 4 || i === 5" target="_blank">
                            <img [src]="assetService.getAssetUrl(list.url)" class="volvo-imgDiv-volvoImg"
                                (load)="onImageLoad(i)" (click)="logTruckModelButtonClick(list.name)" alt="" />
                        </a>
                        <h2 class="truckModel-div-wrapper-title">{{ list.title | lowercase | translate }}</h2>
                        <p class="truckModel-div-wrapper-text"
                            [ngClass]="(i === 4 || i === 5) ? 'truckModel-div-wrapper-text-height' : ''">{{ list.text |
                            lowercase | translate }}</p>

                        <div class="truckModel-div-wrapper">
                            <button *ngIf="i !== 4 && i !== 5" [routerLink]="list.path | localize"
                                class="truckModel-div-wrapper-button" (click)="logTruckModelButtonClick(list.name)"
                                type="button" role="button"
                                [attr.aria-label]="!isTablet ? ('pages/truckModel/readmore' | lowercase | translate) : (list.title | lowercase | translate)">
                                <span class="truckModel-div-wrapper-button-text">
                                    <!-- {{ !isTablet ? ('pages/truckModel/readmore' | lowercase | translate) : (list.title | lowercase | translate) }} -->
                                    {{ 'pages/truckModel/readmore' | lowercase | translate}}
                                </span>
                                <i class="fal fa-chevron-right" aria-hidden="true"></i>
                            </button>

                            <a *ngIf="i === 4 || i === 5" [href]="list.path" class="truckModel-div-wrapper-button"
                                target="_blank" rel="noopener noreferrer" (click)="logTruckModelButtonClick(list.name)"
                                [attr.aria-label]="!isTablet ? ('pages/truckModel/readmore' | lowercase | translate) : (list.title | lowercase | translate)">
                                <span class="truckModel-div-wrapper-button-text">
                                    <!-- {{ !isTablet ? ('pages/truckModel/readmore' | lowercase | translate) : (list.title | lowercase | translate) }} -->
                                    {{ 'pages/truckModel/readmore' | lowercase | translate }}
                                </span>
                                <i class="fal fa-chevron-right" aria-hidden="true"></i>
                            </a>
                        </div>

                    </div>
                </div>
            </ng-container>

        </div>
    </div>
</section>